export const apiRoutes = {
    routeConnected: 'travel/connected/'
}
